import { render, staticRenderFns } from "./SubCategoryModal.vue?vue&type=template&id=02844690&scoped=true"
import script from "./SubCategoryModal.vue?vue&type=script&lang=js"
export * from "./SubCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02844690",
  null
  
)

export default component.exports